const TIMER_VALUE = 300

export default {
	state: {
		timerValue: 0,
		interval: null,
		isTimerStarted: false
	},

	getters: {
		getTimerValue: state => {
			return state.timerValue;
		},

		getInterval: state => {
			return state.interval;
		},

		getIsTimerStarted: state => {
			return state.isTimerStarted;
		}
	},

	mutations: {
		setTimerStarted(state, payload) {
			state.isTimerStarted = payload;
		},

		setTimerValue(state, payload) {
			state.timerValue = payload;
			localStorage.setItem("refresh-cards-timer", payload);
		},

		setInterval(state, payload) {
			state.interval = payload;
		}
	},

	actions: {
		startTimer({ commit, getters }) {
			const timerValue = parseInt(
				localStorage.getItem("refresh-cards-timer")
			);

			if (!timerValue || isNaN(timerValue) || getters.getIsTimerStarted) {
				return;
			}

			commit("setTimerValue", timerValue);

			if (getters.getInterval) {
				clearInterval(getters.getInterval);
			}

			commit(
				"setInterval",
				setInterval(() => {
					if (
						getters.getTimerValue <= 0 ||
						isNaN(getters.getTimerValue)
					) {
						clearInterval(getters.getInterval);
            commit("setTimerStarted", false);
						return;
					}

					commit("setTimerValue", getters.getTimerValue - 1);
				}, 1000)
			);
			commit("setTimerStarted", true);
		},

		updateTimerValue({ commit }) {
			commit("setTimerValue", TIMER_VALUE);
		}
	}
};
